import { render, staticRenderFns } from "./editAd.vue?vue&type=template&id=064c7bf8"
import script from "./editAd.vue?vue&type=script&lang=js"
export * from "./editAd.vue?vue&type=script&lang=js"
import style0 from "./editAd.vue?vue&type=style&index=0&id=064c7bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports